import { GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql/lib/types';

import { serviceSendForgotPassword } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const getServiceSendForgotPassword = async (email: string, fromVenueWeb: boolean): Promise<boolean> => {
  const result = await executeGql(serviceSendForgotPassword, { email, fromVenueWeb }, GRAPHQL_AUTH_MODE.AWS_IAM);
  return processGqlResult<boolean>('data.serviceSendForgotPassword', result);
};
